import { memo, useMemo } from 'react';
import { GridCell } from '../../../../../../../../../api/generated/data-contracts';
import { bigZero } from '../../../../../../../../../helpers/math';
import { useTheme } from '../../../../../../../../../Themes/themeContext';
import { useGridContext } from '../../../../../../../_grid/contexts/gridContext';
import { useFixedCellValue } from '../../../../../../../_grid/hooks/useFixedCellValue';

export const ContractCell = memo(function ContractCell({ cell, cells, containsCategory }: { cell: GridCell; cells: GridCell[]; containsCategory?: boolean }) {
    const { useGridCellValue } = useGridContext();
    const storeValue = useGridCellValue(cell);
    const value = useFixedCellValue(storeValue);
    const styles = useContractCellStyles(cells, containsCategory);
    return <div style={styles}>{value}</div>;
});

const useContractCellStyles = ([requestCell, allocationCell]: GridCell[], containsCategory?: boolean) => {
    const theme = useTheme();
    const { useGridCellValue } = useGridContext();
    const requestValue = useGridCellValue(requestCell);
    const allocationValue = useGridCellValue(allocationCell);

    return useMemo((): React.CSSProperties => {
        let backgroundColor = '';
        if (requestValue.lt(allocationValue)) {
            backgroundColor = theme.semanticColors.activityOverBackground;
        } else if (requestValue.gt(allocationValue)) {
            backgroundColor = theme.semanticColors.activityUnderBackground;
        } else if (requestValue.eq(allocationValue)) {
            if (containsCategory && allocationValue.gt(bigZero)) {
                backgroundColor = theme.semanticColors.activityEqualContainsCategoryBackground;
            } else if (requestValue.eq(bigZero) && allocationValue.eq(bigZero)) {
                backgroundColor = theme.semanticColors.activityZeroBackground;
            } else {
                backgroundColor = theme.semanticColors.activityEqualBackground;
            }
        }

        return {
            paddingRight: 10,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'end',
            backgroundColor,
        };
    }, [
        allocationValue,
        containsCategory,
        requestValue,
        theme.semanticColors.activityEqualBackground,
        theme.semanticColors.activityEqualContainsCategoryBackground,
        theme.semanticColors.activityOverBackground,
        theme.semanticColors.activityUnderBackground,
        theme.semanticColors.activityZeroBackground,
    ]);
};
